import type {Values} from "@wix/devzai-utils-common";

export const BymoPageTextSize = {
    Small: 'Small',
    Medium: 'Medium',
} as const;

export type BymoPageTextSize = Values<typeof BymoPageTextSize>;